<mat-toolbar [style.height.px]="50" color="primary">
  <ng-content></ng-content>

  <span>{{ title }}</span>

  <div class="search-container">
    <app-global-search></app-global-search>
    <!-- <input
      solSearchInput
      placeholder="Search"
      (searchValueChange)="searchValueChanges$.next($event)"
    /> -->
  </div>

  <span style="flex: 1 1 auto"></span>
  <sol-user-avatar [matMenuTriggerFor]="userMenu"></sol-user-avatar>
  <mat-menu #userMenu>
    <button mat-menu-item [routerLink]="['/profile']">
      <mat-icon>person</mat-icon>
      <span>Profile</span>
    </button>
    <button mat-menu-item (click)="onBuildAndConfigureClick()">
      <mat-icon>build</mat-icon>
      <span>Build & Configure</span>
    </button>
    <button mat-menu-item [routerLink]="['/security']">
      <mat-icon>security</mat-icon>
      <span>Security</span>
    </button>
    <button mat-menu-item>
      <mat-icon>settings</mat-icon>
      <span>Settings</span>
    </button>

    <button mat-menu-item (click)="onSignOutClick()">
      <mat-icon>exit_to_app</mat-icon>
      <span>Sign out</span>
    </button>
  </mat-menu>
</mat-toolbar>
